<template>
    <router-link class="button-logo" to="/">
        <Logo class="button-logo__svg">
            <!-- Make the svg Accessible according to ADA Compliance -->
            <title>Logo</title>
            <descr>Go to Homepage</descr>
        </Logo>
    </router-link>
</template>

<script>
import Logo from '@/assets/img/logo.svg'

export default {
    name: 'ButtonLogo',
    components: {
        Logo,
    },
}
</script>

<style lang="scss">
    .button-logo{
        background-color: $orange--neutral-2;
        box-shadow: 0px 6px 8px $orange--shade-8--opaque;
        display: block;
        height: 60px;
        outline: none;
        padding: 12px 20px 18px 20px;
        width: 60px;
        -webkit-tap-highlight-color: transparent;

        path{
            stroke: $orange--shade-7;
            stroke-width: 0.2px;
        }

        &__svg{
            height: 100%;
            width: 100%;
        }
    }

    @media (min-width: $tablet-screen) {
        .button-logo{
            box-shadow: 7px 7px 20px $orange--shade-8--opaque;
            height: 120px;
            padding: 25px 25px 25px 20px;
            width: 125px;
        }
    }
</style>